import React from 'react';

interface USDTIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

export const USDTIcon: React.FC<USDTIconProps> = ({
  width = 22,
  height = 22,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="11" cy="11" r="11" fill="#26A17B" />
      <path
        d="M12.2778 11.6111V11.6167C12.2222 11.6222 11.9444 11.6444 11.5556 11.6444C11.2222 11.6444 10.9833 11.6278 10.8889 11.6167V11.6111C8.94444 11.5444 7.5 11.2444 7.5 10.8889C7.5 10.5333 8.94444 10.2333 10.8889 10.1667V11.4C10.9889 11.4167 11.2444 11.4389 11.5667 11.4389C11.9667 11.4389 12.2167 11.4111 12.2833 11.4V10.1667C14.2222 10.2333 15.6667 10.5333 15.6667 10.8889C15.6667 11.2444 14.2222 11.5444 12.2778 11.6111ZM12.2778 10.0556V8.94444H14.7222V7.77778H8.44444V8.94444H10.8889V10.0556C8.72222 10.1333 7.11111 10.4889 7.11111 10.9167C7.11111 11.3444 8.72222 11.7 10.8889 11.7778V14.2222H12.2778V11.7778C14.4444 11.7 16.0556 11.3444 16.0556 10.9167C16.0556 10.4889 14.4444 10.1333 12.2778 10.0556Z"
        fill="white"
      />
    </svg>
  );
};

export default USDTIcon;
